<template>
  <div>
     <div class="header" ref="headerRef">
        <div class="_1366">
            <img src="https://www.honorreal.com/public/static/index/images/logo.svg" class="header_logo">
            <span class="logo-text">HonorReal </span>
        </div>
     </div>
     <div class="mian_con" :style="{height: mainHeight+'px'}">
        <div class="info">
            <span>招聘简介：</span>红瑞集团把人才看成是企业宝贵的财产，看成红瑞集团走向未来的动力性资本，倡导“快乐地追求卓越”，努力为员工提供可持续发展的机会和空间，倾情创造公平竞争的工作环境，任何一个加入红瑞大家庭的员工付出积极的思考和努力，虚心学习，不断进步，会获得公正的评价和丰厚的回报，快来加入我们吧！
        </div>
        <img src="../assets/bg.png" class="ixintu" alt="" />
       <div class="main">
            <p class="conca">联系我们</p>
            <p class="con">
                <span>咨询电话：+86-18976328575(刘先生)</span>
                <span>微信详谈：<img src="../assets/code.jpg" alt="" class="encode"></span>
                <span>面试地点：海口市五指山南路海阔天空国瑞城铂仕苑南座25层</span>
            </p>
        </div>
      </div>
      <div class="footer" ref="footerRef">
        <div class="_1200">
         <p>Copyright © 2021 红瑞集团 版权所有 <span  @click="handclick('https://beian.miit.gov.cn/#/')">琼ICP备12002330号-3</span> Proudly Presented by HonorReal Technical Groups</p>
        </div>
      </div>
      <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { onMounted, ref } from 'vue'
export default {
  name: 'Home',
  components: {
    // HelloWorld
  },
  meta: {
    title: '海南红瑞集团'
  },
  setup () {
    let mainHeight = ref(0)
    const headerRef = ref(0)
    const footerRef = ref(0)
    onMounted(() => {
      const getMainHeight = () => { // eslint-disable-line no-unused-vars
        let wh = document.documentElement.clientHeight // eslint-disable-line no-unused-vars
        let headerHeith = headerRef.value.offsetHeight // eslint-disable-line no-unused-vars
        let footerHeith = footerRef.value.offsetHeight // eslint-disable-line no-unused-vars
        let mianHg = wh - headerHeith - footerHeith // eslint-disable-line no-unused-vars
        mainHeight.value = mianHg // eslint-disable-line no-unused-vars
      }
      getMainHeight()
      window.onresize = () => {
        getMainHeight()
      }
    })
    // 跳转到域名信息备案管理系统
    const handclick = (href) => { // eslint-disable-line no-unused-vars
      window.open(href, '_blank')
    }
    return {
      headerRef,
      footerRef,
      mainHeight,
      handclick
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
        body{
            margin:0;
        }
        page{
            margin: 0px;
            padding: 0px;
            border: 0px;
            overflow: hidden;
            background: #fafafa;
            position: relative;
        }
        .margined {
            margin: 10px 0px 10px 0px;
        }
        .w100 {
            width: 100%;
        }
        .header{
            background: #ffffff;
            overflow: hidden;
            .header_logo {
            height: 100px;
            .margined();
            float: left;
           }
           .logo-text {
            display: inline-block;
            font-family: "Microsoft YaHei",Arial,Helvetica,sans-serif;
            -webkit-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            transform: translateY(-50%);
            border-left: 1px solid silver;
            padding-left: 15px;
            margin-left: 48px;
            font-size: 24px;
            line-height: 46px;
            margin-top: 60px;
            }
        }
        ._1366{
            width: 1336px;
            margin: auto;
        }
       .footer {
             .w100();
             background: #292929;
             height: 50px;
             position: absolute;
             bottom: 0px;
               p {
            font-size: 18px;
            color: #ababab;
            text-align: center;
            line-height: 50px;
            margin: 0;
               span{
                 cursor: pointer;
                 &:hover{
                 color: #cdc8c8;
               }
               }
            a {
                color: #ababab;
                text-decoration: none;
            }
            }
        }
        .mian_con{
            position: relative;
            .info {
            width: 1060px;
            margin: 30px auto 0px;
            line-height: 30px;
             span{
               font-weight: bold;
              }
            }
            .main{
            width: 740px;
            margin: 62px auto 100px;
            .conca {
            height: 86px;
            font-size: 27px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 30px;
            letter-spacing: 0px;
            text-align: center;
            line-height: 86px;
            border-bottom: 1px solid #c40629;
           }
           .con{
            font-size: 16px;
            color: #2c2c2c;margin-top: 16px;
            .encode {
            width: 100px;
            .margined();
            display: inline-block;
            vertical-align: -45px;
           }
           span {
            display: block;
            border-bottom: 1px dashed #e5e5e5;
            line-height: 60px;
            text-align: left;
          }
          }
        }
        .ixintu{
            position: absolute;
            z-index: -1;
            .w100();
            right: 0px;
            left: 0px;
            filter: Alpha(Opacity=60);
            opacity: 0.06;
            bottom: 0px;
        }
        }
</style>
